// Chart utility functions for candidate selection chart

const DARK_THEME_VAR = 'theme-dark';

export type ChartDataPoint = {
  x: number;
  y: number;
};

export type ChartDataset = {
  label: string;
  data: ChartDataPoint[];
  fill: boolean;
  backgroundColor: string;
  borderColor: string;
  tension: number;
  pointRadius: number;
  pointBackgroundColor: string;
  pointBorderColor: string;
  pointHoverBackgroundColor: string;
  pointHoverBorderColor: string;
  pointHoverRadius: number;
};

export type ChartData = {
  datasets: ChartDataset[];
};

// Function to check for the theme-dark class and return the appropriate text color
export function getChartColor(): string {
  return document.body.classList.contains(DARK_THEME_VAR) ? '#F3F3F3' : '#292929';
}

// Function to check for the theme-dark class and return the appropriate grid line color
export function getChartGridColor(): string {
  return document.body.classList.contains(DARK_THEME_VAR) ? 'rgba(243, 243, 243, 0.2)' : '#EAEAEA';
}

// Create chart data for candidate selection
export function createCandidateSelectionChartData(graphData: any[]): ChartData {
  return {
    datasets: [
      {
        label: 'Number of Candidates',
        data: graphData.map((item: any) => ({ 
          x: item.percentage_fit, 
          y: item.number_of_candidates
        })),
        fill: true,
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)',
        tension: 0.4,
        pointRadius: graphData.length < 50 ? 4 : 3, // Increase visibility for fewer points
        pointBackgroundColor: '#3dcbb1',
        pointBorderColor: '#3dcbb1',
        pointHoverBackgroundColor: '#3dcbb1',
        pointHoverBorderColor: '#3dcbb1',
        pointHoverRadius: graphData.length < 50 ? 6 : 5,
      },
    ],
  };
}

// Create chart options for candidate selection
export function createCandidateSelectionChartOptions(xMin?: number, xMax?: number): any {
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        enabled: true,
      }
    },
    layout: {
      padding: {
        top: 20,
        bottom: 20,
        right: 0
      },
    },
    scales: {
      x: {
        type: 'linear',
        ...(typeof xMin === 'number' && typeof xMax === 'number'
          ? { min: xMin, max: xMax }
          : {}),
        ticks: { stepSize: 1 },
        title: {
          display: true,
          text: 'PERCENTAGE FIT',
          color: getChartColor(),
          font: {
            size: 12,
            weight: 700,
            family: 'Hanken Grotesk, sans-serif',
          },
        },
        grid: {
          display: false
        },
      },
      y: {
        title: {
          display: true,
          text: 'NUMBER OF CANDIDATES',
          color: getChartColor(),
          font: {
            size: 12,
            weight: 700,
            family: 'Hanken Grotesk, sans-serif',
          },
          letterSpacing: 2.76,
          padding: { bottom: 28 },
        },
        grid: {
          display: true,
          color: getChartGridColor(),
        },
        border: {
          color: getChartColor(),
        },
        ticks: {
          padding: 10,
        },
        beginAtZero: true,
      },
    },
  };
}

